import React from 'react';
import { Card, Select, Typography } from 'antd';
import { FolderOpenOutlined, ClockCircleOutlined } from '@ant-design/icons';
import RankingTable from './RankingTable';
import './ModernHistoricalStep.css';

const { Title, Text } = Typography;

const ModernHistoricalStep = ({
                                  existingJDList,
                                  selectedHistoricalJD,
                                  setSelectedHistoricalJD,
                                  getHistoricalData,
                                  jdListLoading,
                                  historicalData,
                                  returnedCriteria,
                                  // RankingTable props
                                  flags,
                                  cycleColor,
                                  handleButtonClick,
                                  handleUnifiedPrescreenClick,
                                  handleSummaryClick,
                                  prescreenLoading,
                                  getPrescreenButtonColor,
                                  isMultiSelect,
                                  selectedCandidates,
                                  setSelectedCandidates,
                                  handleMultiplePrescreen,
                                  ENABLE_MULTISELECT_FEATURE,
                                  backendURL,
                                  jdFilepath, 
                                  jdText,
                                  jobID
                              }) => {
    const handleSelectChange = (value) => {
        setSelectedHistoricalJD(value);
        if (getHistoricalData) {
            getHistoricalData(value);
        }
    };

    return (
        <div className="modern-historical-container">
            <div className="modern-historical-background">
                <div className="modern-historical-content">
                    {/* Header Section */}
                    <div className="modern-historical-header">
                        <Title level={1} className="modern-historical-title">
                            View Previous Results
                        </Title>
                        <Text className="modern-historical-subtitle">
                            Select a previous job description to view results and rankings
                        </Text>
                    </div>

                    {/* Selection Card */}
                    <Card className="modern-historical-card">
                        <div className="historical-card-content">
                            {/* Icon */}
                            <div className="historical-icon-container">
                                <FolderOpenOutlined className="historical-icon" />
                            </div>

                            {/* Dropdown Section */}
                            <div className="historical-dropdown-section">
                                <div className="dropdown-label">Previous Job Descriptions</div>
                                <Select
                                    value={selectedHistoricalJD}
                                    onChange={handleSelectChange}
                                    className="historical-select"
                                    placeholder="Select a job description to view results"
                                    loading={jdListLoading}
                                    size="large"
                                >
                                    {existingJDList.map((jd, index) => (
                                        <Select.Option key={index} value={jd.JDId || ''}>
                                            {jd.JDName || ''}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </div>
                        </div>
                    </Card>

                    {/* Results Section */}
                    {historicalData.length > 0 && (
                        <div className="historical-results-section">
                            <Card className="modern-historical-results-card">
                                <div className="results-header">
                                    <ClockCircleOutlined className="results-icon" />
                                    <Title level={2} className="results-title">
                                        CV Ranking Results
                                    </Title>
                                </div>
                                <div className="results-table-container">
                                    <RankingTable
                                        data={historicalData}
                                        returnedCriteria={returnedCriteria}
                                        flags={flags}
                                        cycleColor={cycleColor}
                                        handleButtonClick={handleButtonClick}
                                        handleUnifiedPrescreenClick={handleUnifiedPrescreenClick}
                                        handleSummaryClick={handleSummaryClick}
                                        prescreenLoading={prescreenLoading}
                                        getPrescreenButtonColor={getPrescreenButtonColor}
                                        isMultiSelect={isMultiSelect}
                                        selectedCandidates={selectedCandidates}
                                        setSelectedCandidates={setSelectedCandidates}
                                        handleMultiplePrescreen={handleMultiplePrescreen}
                                        ENABLE_MULTISELECT_FEATURE={ENABLE_MULTISELECT_FEATURE}
                                        backendURL={backendURL}
                                        jdFilepath={jdFilepath}  
                                        jdText={jdText}
                                        jobID={jobID}
                                    />
                                </div>
                            </Card>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ModernHistoricalStep;